(() => {
  document.addEventListener('dragstart', event => {
    if (event.target instanceof Element && event.target.closest('.product__media-list')) event.preventDefault();
  });
  function init(root = document) {
    const popup = root.querySelector('#ElisaEmailPopup');
    if (!popup || popup.dataset.initialized) return;
    popup.dataset.initialized = 'true';
    const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const write = (key,value) => { try { sessionStorage.setItem(key,value); } catch {} };
    const startKey = 'em-popup-start-v1';
    const doneKey = 'em-popup-seen-v1';
    const started = Number(read(startKey)) || Date.now();
    write(startKey, String(started));
    let timer, previousFocus;
    const close = () => { popup.close(); previousFocus?.focus({preventScroll:true}); };
    popup.querySelectorAll('[data-em-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('click', event => { if(event.target===popup){ const r=popup.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) close(); } });
    const open = () => { if(!popup.isConnected || popup.open) return; previousFocus=document.activeElement; popup.showModal(); write(doneKey,'1'); };
    const form = popup.querySelector('#ElisaPopupForm');
    const success = popup.querySelector('[data-em-success]');
    const entry = popup.querySelector('[data-em-entry]');
    const pendingKey = 'em-popup-pending-v1';
    form.addEventListener('submit', () => write(pendingKey, String(Date.now())));
    const params = new URLSearchParams(location.search);
    const pending = Number(read(pendingKey));
    const returned = params.get('em_signup') === 'success' && pending > 0 && Date.now() - pending < 3600000;
    const showSuccess = returned || (success && !success.hidden);
    popup.querySelector('[data-em-copy]').addEventListener('click', async () => {
      const status = popup.querySelector('[data-em-copy-status]');
      try {
        await navigator.clipboard.writeText('Elisa10');
        status.textContent = '¡Copiado! Úsalo al finalizar tu compra.';
      } catch {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(popup.querySelector('.em-email-code'));
        selection.removeAllRanges(); selection.addRange(range);
        status.textContent = 'Código seleccionado: mantén presionado y elige Copiar.';
      }
    });
    if(showSuccess) {
      success.hidden = false; entry.hidden = true;
      popup.setAttribute('aria-labelledby','ElisaPopupSuccessTitle');
      write(pendingKey, '');
      open();
      return;
    }
    if(popup.querySelector('[data-em-error]')) { open(); return; }
    if(read(doneKey)) return;
    const showWhenReady = () => {
      if(document.hidden || document.querySelector('cart-drawer.active, dialog[open], .scale-menu details[open]')) { timer=setTimeout(showWhenReady,1000); return; }
      open();
    };
    timer=setTimeout(showWhenReady, Math.max(0, Number(popup.dataset.delay) - (Date.now()-started)));
    document.addEventListener('shopify:section:unload', event=>{if(event.target.contains(popup))clearTimeout(timer);},{once:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();